import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { CustomContent } from '../../custom-content';
import { SignUpStepOneComponent } from './sign-up-step-one.component';
import { SubmitErrorStateMatcher } from './submit-error-state-matcher';

const DEFAULT_CONTENT = CustomContent.getValue('');
const V2_COPY_KEYS: Record<string, string> = {
  [DEFAULT_CONTENT.formTitle ?? '']: 'SIGNUP.SETUP.STEP_ONE_TRIAL.TRIAL_TITLE_V2',
  [DEFAULT_CONTENT.formSubtitle ?? '']: '',
};

@Component({
  selector: 'app-sign-up-step-one-v2',
  styleUrls: ['./sign-up-step-one-v2.component.scss'],
  templateUrl: './sign-up-step-one-v2.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  providers: [SubmitErrorStateMatcher, { provide: ErrorStateMatcher, useExisting: SubmitErrorStateMatcher }],
})
export class SignUpStepOneV2Component extends SignUpStepOneComponent {
  v2Key(key?: string | null): string {
    if (!key) {
      return '';
    }
    return key in V2_COPY_KEYS ? V2_COPY_KEYS[key] : key;
  }
}
